export function formatFileSize(bytes: number): string {
  if (bytes === 0) {
    return "0 Bytes";
  }

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

/**
 * Display label for an enum-like value: splits on `_`, `-`, and whitespace and capitalizes the
 * first letter of every word (`"ready_for_review"` → `"Ready For Review"`). The rest of each word
 * is kept as-is so acronyms survive (`"PDF_export"` → `"PDF Export"`). Only for values we own —
 * never user content.
 */
export function toTitleCase(value: string): string {
  return value
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
